import { api } from '@repo/core/config';
import { Client, Entity } from '@repo/core/models';

export const useEntityService = () => {
  const getCurrent = async (parameters?: string): Promise<Entity> => {
    parameters = parameters || '';
    try {
      const response = await api.get(`entities/getCurrent${parameters}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const get = async (parameters?: string): Promise<Entity[]> => {
    parameters = parameters || '';
    try {
      const response = await api.get(`entities${parameters}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const getEntity = async (id: string): Promise<Entity> => {
    try {
      const response = await api.get(`entities/${id}`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const engagements = async (): Promise<Client[]> => {
    try {
      const response = await api.get(`entities/engagements`);
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const post = async (data: Entity[], options?: any): Promise<Entity[]> => {
    if (!options) options = {};
    options.autoSave = options.autoSave != null ? options.autoSave : true;

    try {
      const response = await api.post(`entities`, data, { headers: options });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const deleteEntities = async (keys: string[]) => {
    try {
      const response = await api.delete(`entities/keys`, { data: '"' + keys + '"' });
      return response.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    get,
    getCurrent,
    getEntity,
    engagements,
    post,
    deleteEntities
  };
};
